// extracted by mini-css-extract-plugin
export default {"Container":"Loader_Container__Gp7Kx","RouterLoaderAnimation":"Loader_RouterLoaderAnimation__PlxOO","Spinner":"Loader_Spinner__Ri+bd","SpinnerEl":"Loader_SpinnerEl__HPWWv"};